import React from "react";
import "./HeaderBar.css";
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaUser, FaUserPlus } from 'react-icons/fa';

const HeaderBar = () => {
  return (
    <div className="header-bar">
      <div className="social-links">
        <span>Follow us on:</span>
        <span className="disabled-icon" aria-label="Facebook">
          <FaFacebook />
        </span>
        <span className="disabled-icon" aria-label="Twitter">
          <FaTwitter />
        </span>
        <span className="disabled-icon" aria-label="Instagram">
          <FaInstagram />
        </span>
        <a href="https://www.youtube.com/@BookLocal" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
          <FaYoutube />
        </a>
      </div>
      <div className="user-links">
        <a href="https://www.booklocal.co.in/">
          <FaUser /> Login
        </a>
        <span className="link-separator">or</span>
        <a href="https://www.booklocal.co.in/">
          <FaUserPlus /> Patient Sign Up
        </a>
      </div>
    </div>
  );
};

export default HeaderBar;